import IAnagrafica, { exampleAnagrafica } from "./IAnagrafica";
import INota from "./INota";

export default interface IAccount {
    Id: number;
    Id_Anagrafica: number;
    Email: string;
    Password: string;
    Creation: string;
    Timestamp: string;

    //* NotMapped
    Anagrafica: IAnagrafica;
    NewPassword: string;
    NewPasswordConfirm: string;
    Note: INota[];
}

export const exampleAccount: IAccount = {
    Id: 0,
    Id_Anagrafica: 0,
    Email: '',
    Password: '',
    Creation: '',
    Timestamp: '',

    Anagrafica: exampleAnagrafica,
    NewPassword: '',
    NewPasswordConfirm: '',
    Note: [],
};
